<template>
  <div class="erm_dashboard_overview">
    <div class="erm_overview_card_warper">
      <div class="erm_menu_item_card">
        <span class="dashicons dashicons-food erm_icon"></span>
        <div class="erm_menu_card_details ">
          <h5 class="erm_title">Total Menu</h5>
          <p class="erm_total">{{ total_menus }}</p>
          <router-link to="/menus" class="erm_view_all">Total Menu</router-link>
        </div>
      </div>

      <div class="erm_menu_item_card">
        <span class="dashicons dashicons-food erm_icon"></span>
        <div class="erm_menu_card_details ">
          <h5 class="erm_title">Total Category</h5>
          <p class="erm_total">{{ total_category }}</p>
          <router-link to="/category" class="erm_view_all">Total category</router-link>
        </div>
      </div>
      <div class="erm_menu_item_card">
        <span class="dashicons dashicons-food erm_icon"></span>
        <div class="erm_menu_card_details ">
          <h5 class="erm_title">Total Reservations Table</h5>
          <p class="erm_total">{{ total_reservation_table }}</p>
          <router-link to="/reservation_table" class="erm_view_all">Total Reservations Table</router-link>
        </div>
      </div>

    </div>

    <AppTable v-loading="loading" :tableData="menus">
      <template #header>
        <h1 class="table-title">Latest Menu</h1>
      </template>

      <template #columns>
        <el-table-column prop="id" label="ID" width="60" />
        <el-table-column label="Image" width="auto">
          <template #default="{ row }">
            <img v-if="row?.image" :src="row?.image" alt="image" style="width: 60px; height: 60px; object-fit: cover;">
            <span v-else>No Image</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Name" width="auto" />
        <el-table-column prop="base_price" label="Price" width="auto" />
        <el-table-column prop="availability" label="Availability" width="auto" />
        <el-table-column prop="added_date" label="Created Date" width="auto">
          <template #default="{ row }">
            {{ formatAddedDate(row.created_at) }}
          </template>
        </el-table-column>

      </template>
    </AppTable>



  </div>
</template>
<script>
import axios from 'axios';
import AppTable from './AppTable.vue'
export default {
  name: 'Dashboard',
  components: {
    AppTable,
  },
  data() {
    return {
      loading: false,
      menus: [],
      total_menus: 0,
      total_category: 0,
      total_reservation_table: 0,
      rest_api: window.RestaurantMenuMangeData.rest_api,
      nonce: window.RestaurantMenuMangeData.nonce
    }
  },
  methods: {
    formatAddedDate(date) {
      if (!date) return '';
      const options = { day: 'numeric', month: 'long', year: 'numeric' };
      return new Date(date).toLocaleDateString('en-GB', options);
    },

    async getMenu() {
      this.loading = true;
      try {
        const response = await axios.get(`${this.rest_api}/getMenu`, {
          headers: {
            'X-WP-Nonce': this.nonce
          }
        });

        this.menus = response.data?.latest_menu;
        this.total_menus = response.data?.menus.length;
        console.log('response', response.data?.menus.length);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error('Error fetching couriers:',);
      }
    },
    async getCategory() {
      this.loading = true;
      try {
        const response = await axios.get(`${this.rest_api}/getCategory`, {
          headers: {
            'X-WP-Nonce': this.nonce
          }
        });
        this.total_category = response.data?.category_data?.length;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error('Error fetching couriers:',);
      }
    },
    async getReservation() {
      this.loading = true;
      try {
        const response = await axios.get(`${this.rest_api}/getReservation`, {
          headers: {
            'X-WP-Nonce': this.nonce
          }
        });
        console.log('response', response.data);
        this.total_reservation_table = response.data?.reservations?.length;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error('Error fetching couriers:',);
      }
    },
  },
  mounted() {

    this.getMenu();
    this.getCategory();
    this.getReservation();

  }
}
</script>

<style lang="scss">
.erm_menu_card_details {
  .erm_title {
    font-size: 15px !important;
    font-weight: 500 !important;
  }
  .erm_total{
    font-size: 22px !important;
    font-weight: 600 !important;
  }
}
</style>